export default __webpack_public_path__ + "static/media/investor-analysis.3b8fe3f4.svg";